export default {
  maps: {
    'pageTitle': 'CycleAI',
    'Places': 'Luoghi',
    'isochrones': 'Isocrone',
    'placeNameRequired': 'Nome del luogo richiesto',
    'altitude': 'Variazioni dell\'altitudine',
    'settings': 'Impostazioni',
    'toggleAccessibleMode': 'Attiva/disattiva opzione d\'accessibilità',
    'aboutTitle': 'Chi siamo',
    'updateSearch': 'Cerca nelle vicinanze',
    'updateSearchAfterZoomOrCenterChange': 'Aggiorna ricerca dopo zoom o cambio centro'
  }
}
